import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../store";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../../../acions/profiles";
import ROUTES from "../../../../configs/routesConfig";

export const useUpdate = (isPasswordValid: boolean) => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);

  const update = useCallback(
    (values: any) => {
      if (isPasswordValid) {
        setIsFormDisabled(true);

        const request = {
          oldPassword: values.oldPassword,
          newPassword: values.password,
        };

        Promise.resolve(dispatch(changePassword(request)))
          .then(() => {
            setIsFormDisabled(false);
            navigate(ROUTES.PROFILE);
          })
          .catch(() => {
            setIsFormDisabled(false);
          });
      }
    },
    [dispatch, isPasswordValid, navigate]
  );

  return { isFormDisabled, update };
};
